import ThirdPartyServiceModel from "../../../models/thirdparty/ThirdPartyServiceModel";
import ThirdPartyServiceForm, {ThirdPartyServiceFormBody} from "../ThirdPartyServiceForm";
import React from "react";
import {useTranslation} from "react-i18next";
import Collapsable from "../../common/Collapsable/Collapsable";
import HTMLTextInput from "../../common/HTMLTextInput/HTMLTextInput";

const allowedAuthenticationMethods = [
    ThirdPartyServiceModel.AuthenticationMethod.API_KEY
];

const initialState = {
    type: ThirdPartyServiceModel.Type.VERITONE,
    serviceName: '',
    enabled: true,
    description: '',
    whitelistedCertFingerprints: [],

    url: '',

    authenticationScope: ThirdPartyServiceModel.AuthenticationScope.SERVICE,
    authenticationMethod: allowedAuthenticationMethods[0],
    authenticationServiceId: null
};

function VeritoneServiceForm() {
    return (
        <ThirdPartyServiceForm initialState={initialState} FormBody={VeritoneServiceFormBody}/>
    )
}

export function VeritoneServiceFormBody(props) {
    return (
        <ThirdPartyServiceFormBody {...props}
            allowedAuthenticationMethods={allowedAuthenticationMethods} FormBody={FormBody}/>
    )
}

function FormBody(props) {
    const {t} = useTranslation(['thirdPartyService', 'common']);
    const {
        thirdPartyService,

        inputHandler,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.veritoneSettings')} isDisabled={isDisabled}>
            <div className="display-input">
                <HTMLTextInput label={t('thirdPartyService:label.url')} name={'url'}
                    value={thirdPartyService.url} onChange={inputHandler} isDisabled={isDisabled} isRequired/>
            </div>
        </Collapsable>
    );
}

export default VeritoneServiceForm;
